module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "list-group discussions"
  }, [(_vm.post) ? _c('li', {
    staticClass: "discussion clearfix",
    class: {
      'moderated': _vm.post.moderated == true,
    },
    attrs: {
      "id": 'post' + _vm.post.id
    }
  }, [(_vm.post.moderated !== true) ? _c('div', {
    staticClass: "panel clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('img', {
    attrs: {
      "src": _vm.post.poster.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("Posted By:"), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "role-icon",
    attrs: {
      "src": _vm._f("roleIcon")(_vm.post.poster.roles, _vm.post.poster.terms)
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'posts-by-user',
        query: {
          userId: _vm.post.poster.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.post.poster.firstName) + " " + _vm._s(_vm.post.poster.lastName))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm._f("timeSince")(_vm.post.createdAt)) + " ago")], 1)]), _vm._v(" "), (_vm.editMode === true && _vm.post.topLevel) ? _c('div', {
    staticClass: "col-xs-10 form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "New Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [(_vm.topicCategories && _vm.editMode === false) ? _c('div', {
    staticClass: "categories"
  }, [_vm._v("\n                            Categories: \n                            "), _vm._l((_vm.topicCategories), function(category, $i) {
    return _c('router-link', {
      attrs: {
        "to": {
          name: 'discussion',
          params: {
            forumId: _vm.forumId
          },
          query: {
            filter_type: category.type,
            filter_id: category.id
          }
        }
      }
    }, [($i != 0) ? _c('span', {
      staticClass: "lowlight"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(category.name))])
  }), _vm._v("\n                            \n                            Tags:\n                            "), _vm._l((_vm.tags), function(tag, $i) {
    return _c('router-link', {
      attrs: {
        "to": {
          name: 'discussion',
          params: {
            forumId: _vm.forumId
          },
          query: {
            tag: tag.id
          }
        }
      }
    }, [($i != 0) ? _c('span', {
      staticClass: "lowlight"
    }, [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("ucwords")(tag.name)))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.editMode === true) ? _c('div', [(_vm.localStorage.roles.indexOf('Student') > -1 && _vm.post.topLevel) ? _c('div', {
    staticClass: "form-group col-sm-12 nopad categories"
  }, [_c('label', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 nopad"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.term),
      expression: "selectedCategories.term"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.term === ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.term = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": "",
      "disabled": ""
    }
  }, [_vm._v("Term")]), _vm._v(" "), _vm._l((_vm.categories.term), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                                            " + _vm._s(term.name) + "\n                                        ")])
  })], 2)]), _vm._v(" "), (_vm.selectedTermType !== 'foundation') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.path),
      expression: "selectedCategories.path"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.path === ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.path = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v("Learning Path")]), _vm._v(" "), _vm._l((_vm.categories.path), function(path) {
    return _c('option', {
      domProps: {
        "value": path.id
      }
    }, [_vm._v("\n                                            " + _vm._s(path.name) + "\n                                        ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 nopad"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategories.assignment),
      expression: "selectedCategories.assignment"
    }],
    staticClass: "form-control",
    class: {
      'placeholder': _vm.selectedCategories.assignment === ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategories.assignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "default": ""
    }
  }, [_vm._v("Assignment")]), _vm._v(" "), _vm._l((_vm.categories.assignment), function(assignment) {
    return (_vm.canSeeAssignment(assignment)) ? _c('option', {
      domProps: {
        "value": assignment.id
      }
    }, [_vm._v("\n                                            " + _vm._s(assignment.name) + "\n                                        ")]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.post.topLevel) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "tags",
      "type": "text",
      "placeholder": "Type a tag and press Enter or select one from the list"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.addTag()
      }
    }
  }), _vm._v(" "), _c('typeahead', {
    attrs: {
      "target": "#tags",
      "match-start": "",
      "data": _vm.availableTags,
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return _vm._l((props.items), function(item, index) {
          return _c('li', [_c('a', {
            attrs: {
              "role": "button"
            },
            on: {
              "click": function($event) {
                _vm.pushTag(item);
                _vm.newTag = null
              }
            }
          }, [_vm._v("\n                                        " + _vm._s(_vm._f("ucwords")(item.name)) + "\n                                      ")])])
        })
      }
    }]),
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "post-tags clearfix"
  }, _vm._l((_vm.tags), function(tag, $index) {
    return _c('li', [_vm._v(_vm._s(_vm._f("ucwords")(tag.name))), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.tags.splice($index, 1)
        }
      }
    }, [_vm._v("x")])])
  }))], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editMode === false) ? _c('div', {
    staticClass: "content post-content",
    class: {
      'answer': _vm.post.isAnswer
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.post.body))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answer && _vm.answer !== null) ? _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Posted by " + _vm._s(_vm.answer.poster.firstName) + " " + _vm._s(_vm.answer.poster.lastName) + " on " + _vm._s(_vm._f("shortDate")(_vm.answer.createdAt)))]), _vm._v(" "), _c('div', {
    staticClass: "content post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.answer.body))
    }
  }), _vm._v(" "), (_vm.threadCreator == _vm.localStorage.user_id) ? _c('button', {
    staticClass: "btn btn-danger btn-answer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unmarkAnswer(_vm.answer.id)
      }
    }
  }, [_vm._v("Unmark Answer")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editMode === true) ? _c('vue-html5-editor', {
    attrs: {
      "content": _vm.post.body,
      "height": 300
    },
    on: {
      "change": _vm.editContent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode === false) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reply(_vm.post.body, _vm.post.poster.firstName, _vm.post.poster.lastName)
      }
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), (_vm.post.isAnswer !== true && _vm.post.topLevel !== true && _vm.threadCreator == _vm.localStorage.user_id) ? _c('button', {
    staticClass: "btn btn-success btn-answer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.markAsAnswer(_vm.post.id)
      }
    }
  }, [_vm._v("Mark As Answer")]) : _vm._e(), _vm._v(" "), (_vm.post.isAnswer == true && _vm.post.topLevel !== true && _vm.threadCreator == _vm.localStorage.user_id) ? _c('button', {
    staticClass: "btn btn-danger btn-answer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unmarkAnswer(_vm.post.id)
      }
    }
  }, [_vm._v("Unmark Answer")]) : _vm._e(), _vm._v(" "), (_vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatePost(_vm.post.id)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.post.createdBy === _vm.localStorage.user_id && _vm.editMode === false) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editMode = !_vm.editMode
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.post.createdBy === _vm.localStorage.user_id && _vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editMode = !_vm.editMode
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.editMode === false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roles.indexOf('Supervisor') > -1 || _vm.post.createdBy === _vm.localStorage.user_id),
      expression: "roles.indexOf('Supervisor') > -1 || post.createdBy === localStorage.user_id"
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteComment($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11a952b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/discussion/DiscussionPost.vue
// module id = 1955
// module chunks = 2